import { type StudyCompareImage } from '@/entities/modal';

import { type ReportPreviewSlide } from '../config';

type CompareImages = {
  images: StudyCompareImage[];
  mainID: string;
  secondaryID: string;
};

const toCompareImage = (slide: ReportPreviewSlide): StudyCompareImage => ({
  reportID: slide.id,
  previewSrc: slide.previewSrc,
  title: slide.title,
  date: slide.date,
});

// Slides are newest first: the latest report leads; by default it is compared
// with the next report of the same type from another scan, otherwise with the
// next report of any type. Every slide stays selectable in the dialog.
export const getCompareImages = (
  slides: ReportPreviewSlide[],
): CompareImages | null => {
  const [main, next] = slides;

  if (!main || !next) {
    return null;
  }

  const sameType = slides.find(
    (slide) =>
      slide.id !== main.id &&
      slide.reportType === main.reportType &&
      slide.studyID !== main.studyID,
  );

  return {
    images: slides.map(toCompareImage),
    mainID: main.id,
    secondaryID: (sameType ?? next).id,
  };
};
